import { Outlet } from 'react-router';
import { useDoc } from '@/lib/firestore/hooks';
import { settingsDoc } from '@/lib/firestore/refs';
import { modal, toast } from '@/lib/ui';
import type { GeneralSettings } from '@shared/types';
import { useAuth } from './use-auth';
import { useIdleTimeout } from './use-idle-timeout';

/** Signs the user out after settings/general.sessionTimeoutMinutes of inactivity, warning a minute before. */
export function SessionGuard() {
  const { signOut } = useAuth();
  const { data } = useDoc(settingsDoc<GeneralSettings>('general'));
  const minutes = data?.sessionTimeoutMinutes ?? 30;

  useIdleTimeout({
    minutes,
    onWarn: () =>
      modal.open({
        title: 'Still there?',
        body: <p>You will be signed out in 60 seconds due to inactivity.</p>,
        footer: <button type="button" className="btn btn-primary" onClick={() => modal.close()}>Stay signed in</button>,
      }),
    onTimeout: async () => {
      modal.close();
      await signOut();
      toast.info('You were signed out after a period of inactivity.');
    },
  });
  return <Outlet />;
}
